import Intercom from '@intercom/messenger-js-sdk';

window.addEventListener('DOMContentLoaded', () => {
  if (!document.dataset.hotwireNative) {
    Intercom({
      app_id: 'v95cgg5k'
    })
  }
});